// eslint-disable-next-line @typescript-eslint/no-empty-function
export var noop = function () { };
//# sourceMappingURL=noop.js.map